<template>
    <v-dialog v-model="isOpen" max-width="500">
        <v-card v-if="!isFinished">
            <v-card-title class="headline">
                {{$t('credit_score.answer_questions')}}
            </v-card-title>
            <v-card-subtitle class="mt-1">
                <span>{{$t('credit_score.calculate_score')}}.</span>
            </v-card-subtitle>
            <v-card-text>
                <v-window v-model="step">
                    <v-window-item :value="0">
                        <p class="score-question text--bold text-center mt-1">{{questions[0].question}}</p>
                        <v-list rounded>
                            <v-list-item-group v-model="questions[0].selected" color="primary">
                                <v-list-item v-for="(item, i) in questions[0].answers" :key="i">
                                    <v-list-item-content @click="next()">
                                        <v-list-item-title v-text="item.description"></v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-window-item>

                    <v-window-item :value="1">
                        <p class="score-question text--bold text-center mt-1">{{questions[1].question}}</p>
                        <v-list rounded>
                            <v-list-item-group v-model="questions[1].selected" color="primary">
                                <v-list-item v-for="(item, i) in questions[1].answers" :key="i">
                                    <v-list-item-content @click="next()">
                                        <v-list-item-title v-text="item.description"></v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-window-item>

                    <v-window-item :value="2">
                        <p class="score-question text--bold text-center mt-1">{{questions[2].question}}</p>
                        <v-list rounded>
                            <v-list-item-group v-model="questions[2].selected" color="primary">
                                <v-list-item v-for="(item, i) in questions[2].answers" :key="i">
                                    <v-list-item-content @click="next()">
                                        <v-list-item-title v-text="item.description"></v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-window-item>

                    <v-window-item :value="3">
                        <p class="score-question text--bold text-center mt-1">{{questions[3].question}}</p>
                        <v-list rounded>
                            <v-list-item-group v-model="questions[3].selected" color="primary">
                                <v-list-item v-for="(item, i) in questions[3].answers" :key="i">
                                    <v-list-item-content @click="next()">
                                        <v-list-item-title v-text="item.description"></v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-window-item>

                    <v-window-item :value="4">
                        <p class="score-question text--bold text-center mt-1">{{questions[4].question}}</p>
                        <v-list rounded>
                            <v-list-item-group v-model="questions[4].selected" color="primary">
                                <v-list-item v-for="(item, i) in questions[4].answers" :key="i" @click="canContinue ? complite() : undefined">
                                    <v-list-item-content>
                                        <v-list-item-title v-text="item.description"></v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-window-item>
                </v-window>
            </v-card-text>
            <div v-if="user && user.credit_score === null">
                <p class="text-center">
                    <span class="caption score-skip" @click="skip()">{{$t('skip')}}</span>
                </p>
            </div>
            <v-divider class="ma-0"></v-divider>

            <v-card-actions class="justify-space-between pa-4">
                <v-btn :disabled="step === 0" text @click="prev">
                    <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-item-group v-model="step" class="text-center hidden-xs-only" mandatory>
                    <v-item v-for="(item, index) in questions" :key="`btn-${index}`" v-slot:default="{ active, toggle }">
                        <v-btn :input-value="active" icon @click="toggle">
                            <v-icon small>mdi-record</v-icon>
                        </v-btn>
                    </v-item>
                </v-item-group>
                <v-btn text @click="next" v-if="step < 4">
                    <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
                <v-btn color="primary" text v-if="step >= 4" @click="complite()">
                    {{$t('complite')}}
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-card v-if="isFinished">
            <v-card-title class="headline">
                <span>{{$t('credit_score.your_score', {score: __score})}}.</span>
            </v-card-title>
            <v-card-subtitle class="mt-1">
                <span>{{$t('credit_score.info')}}</span>
            </v-card-subtitle>
            <v-card-text>
                <v-row class="mt-n6">
                    <v-col>
                        <CreditScoreChart height="240px" :score="__score"></CreditScoreChart>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <p>
                            <span v-html="$t(`credit_score.status.${scoreStatus}`)"></span>
                        </p>
                        <p class="mt-8 caption">* {{$t('credit_score.own_model')}}</p>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider class="ma-0 pa-0"></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="close()">{{$t('close')}}</v-btn>
            </v-card-actions>
        </v-card>
        <OverlayLoader :show="isLoading"></OverlayLoader>
    </v-dialog>
</template>

<script>
    import CreditScoreService from "../services/creditScoreService";
    import OverlayLoader from '@/app/shared/components/app-loader/Loader';
    import CreditScoreChart from '@/app/client/profile/shared/components/creditScoreChart';

    export default {
        name: 'CreditScoreQuestionsModal',
        components: {
            CreditScoreChart,
            OverlayLoader
        },
        data() {
            return {
                step: 0,
                __score: 0,
                isLoading: false,
                isFinished: false,
                questions: [
                    {
                        question: this.$t('credit_score.questions.q1.header'),
                        answers: [
                            { description: this.$t('credit_score.questions.q1.a1'), value: 2 },
                            { description: this.$t('credit_score.questions.q1.a2'), value: 1 },
                            { description: this.$t('credit_score.questions.q1.a3'), value: 3 },
                            { description: this.$t('credit_score.questions.q1.a4'), value: 4 },
                            { description: this.$t('credit_score.questions.q1.a5'), value: 5 },
                        ],
                    },
                    {
                        question: this.$t('credit_score.questions.q2.header'),
                        answers: [
                            { description: this.$t('credit_score.questions.q2.a1'), value: 6 },
                            { description: this.$t('credit_score.questions.q2.a2'), value: 4 },
                            { description: this.$t('credit_score.questions.q2.a3'), value: 5 },
                            { description: this.$t('credit_score.questions.q2.a4'), value: 3 },
                            { description: this.$t('credit_score.questions.q2.a5'), value: 2 },
                            { description: this.$t('credit_score.questions.q2.a6'), value: 1 },
                        ],
                    },
                    {
                        question: this.$t('credit_score.questions.q3.header'),
                        answers: [
                            { description: this.$t('credit_score.questions.q3.a1'), value: 1 },
                            { description: this.$t('credit_score.questions.q3.a2'), value: 2 },
                            { description: this.$t('credit_score.questions.q3.a3'), value: 3 },
                            { description: this.$t('credit_score.questions.q3.a4'), value: 4 },
                            { description: this.$t('credit_score.questions.q3.a5'), value: 5 },
                        ],
                    },
                    {
                        question: this.$t('credit_score.questions.q4.header'),
                        answers: [
                            { description: this.$t('credit_score.questions.q4.a1'), value: 1 },
                            { description: this.$t('credit_score.questions.q4.a2'), value: 4 },
                            { description: this.$t('credit_score.questions.q4.a3'), value: 5 },
                            { description: this.$t('credit_score.questions.q4.a4'), value: 6 },
                            { description: this.$t('credit_score.questions.q4.a5'), value: 7 },
                            { description: this.$t('credit_score.questions.q4.a6'), value: 3 },
                            { description: this.$t('credit_score.questions.q4.a7'), value: 2 },
                        ],
                    },
                    {
                        question: this.$t('credit_score.questions.q5.header'),
                        answers: [
                            { description: this.$t('credit_score.questions.q5.a1'), value: 1 },
                            { description: this.$t('credit_score.questions.q5.a2'), value: 2 },
                            { description: this.$t('credit_score.questions.q5.a3'), value: 3 },
                            { description: this.$t('credit_score.questions.q5.a4'), value: 4 },
                            { description: this.$t('credit_score.questions.q5.a5'), value: 5 },
                            { description: this.$t('credit_score.questions.q5.a6'), value: 6 },
                        ],
                    },
                ],
            }
        },
        computed: {
            selectedAnswers() {
                let complitedQuestions = this.questions.filter(item => item.hasOwnProperty('selected'));
                return complitedQuestions.map(item => item.answers[item.selected]);
            },
            answersCount() {
                return this.questions.reduce((prev, current) => {
                    return prev + current.answers.length
                }, 0);
            },
            isOpen: {
                get() {
                    return this.$store.getters.IS_CREDIT_SCORE_MODAL_OPENED;
                },
                set(val) {
                    this.$store.dispatch('OPEN_CREDIT_SCORE_MODAL', val)
                }
            },
            scoreStatus() {
                return CreditScoreService.status(this.__score)
            },
            canContinue() {
                return this.selectedAnswers.length >= this.questions.length - 1;
            },
            user() {
                return this.$store.getters.AUTH_USER;
            }
        },
        methods: {
            next() {
                if (this.step < 4) this.step++;
            },
            prev() {
                if (this.step > 0) this.step--;
            },
            randomInteger(min, max) {
                return Math.floor(Math.random() * (max - min + 1)) + min;
            },
            countScore() {
                const ratio = (999 - this.randomInteger(565, 585)) / this.answersCount;
                const answerValues = this.selectedAnswers.reduce((prev, current) => {
                    return current ? prev + current.value : prev;
                }, 0);
                return 565 + Math.floor(answerValues * ratio);
            },
            complite() {
                this.__score = this.countScore();
                this.isLoading = true;
                this.$store.dispatch('SET_USER_CREDIT_SCORE', this.__score)
                    .then(() => {
                        this.$store.dispatch('GET_CS_OFFERS');
                        setTimeout(() => {
                            this.isLoading = false;
                            this.isFinished = true;
                        }, 2000);
                    })
                    .catch(error => this.$toast.error(error));
            },
            skip() {
                this.$store.dispatch('SET_USER_CREDIT_SCORE', 0);
                this.$store.dispatch('OPEN_CREDIT_SCORE_MODAL', false);
            },
            close() {
                this.$store.dispatch('OPEN_CREDIT_SCORE_MODAL', false)
            },
            refreshAnswers() {
                this.questions.forEach(item => delete item.selected);
            }
        },
        watch: {
            isOpen() {
                this.step = 0;
                this.isFinished = false;
                this.refreshAnswers();
            }
        }
    }
</script>

<style>
    .score-question {
        font-size: 22px;
    }
    .score-skip {
        text-decoration: underline;
        cursor: pointer;
    }
</style>
